module.exports = __webpack_public_path__ + "img/PowerOff.a5105fac.png";